import { CircularProgress } from "@material-ui/core";
import { Dialog, DialogTitle, DialogContent } from "@material-ui/core";
import { Typography, Button, DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";

// Connectors
import backendConnector from "../../../services/connectors/backendConnector";

// Services
import sessionStorage from "../../../services/storage/SessionStorage";

// Styles
import DeleteAssessmentPopoverStyle from "../../../assets/styles/materialUI/questionnaire/assessmentResult/DeleteAssessmentPopoverStyle";

// Providers
import { useLanguage } from "../../../contexts/languageContext";

export default function DeleteAssessmentPopover({
	setError,
	setMessage,
	partialLoading,
	setPartialLoading,
	deleteConfirm,
	setDeleteConfirm,
	selectedAssessment,
	initiateResult,
}) {
	const { t } = useTranslation();
	const { direction } = useLanguage();
	const classes = DeleteAssessmentPopoverStyle();

	const confirmDelete = async () => {
		setError(null);
		setPartialLoading(true);
		let sessionData = {
			submission_id: selectedAssessment?.id,
		};
		let response = await backendConnector.deleteSubmission(sessionData);
		if (response?.error) {
			setError(response?.error);
		} else if (response?.message) {
			sessionStorage.clearPath("session_id");
			setMessage(response?.message);
		} else {
			setError("common.errors.generic");
		}
		await initiateResult(false);
		setPartialLoading(false);
		setDeleteConfirm(false);
	};

	const handleCloseDialogs = () => {
		setDeleteConfirm(false);
	};

	return (
		<Dialog open={deleteConfirm} onClose={handleCloseDialogs} dir={direction} maxWidth="sm" fullWidth>
			<DialogTitle className={classes.dialogTitle}>{t("assessment.results.history.delete.title")}</DialogTitle>
			<DialogContent>
				<Typography variant="body1">
					{t("assessment.results.history.delete.body", {
						nameOrDate: selectedAssessment?.name || selectedAssessment?.date || "",
					})}
				</Typography>
			</DialogContent>
			<DialogActions className={classes.actionButtonContainer}>
				<Button
					onClick={handleCloseDialogs}
					variant="contained"
					color="primary"
					className={classes.cancelButton}
				>
					{t("common.buttons.cancel")}
				</Button>
				<Button onClick={confirmDelete} className={classes.deleteButton} variant="contained" color="primary">
					{partialLoading ? (
						<CircularProgress size={18} className={classes.progressIcon} />
					) : (
						t("common.buttons.delete")
					)}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
